define('shared/remote/redemption/validate',[
    'shared/lib/RSVP', 
    'shared/remote/ajax',
],
function (
    RSVP, 
    ajax
) {
    'use strict';

    return function newHouse(options) {
        var redemptionCode = options.redemptionCode;
        return ajax({
            url: '/1/api/commerce-gateway/redemption/' + redemptionCode + '/validate',
            type: 'GET',
            dataType: 'json'
        })
        .then(function(json){
            return json;
        }, function(xhr) {
            if (xhr.status === 404) {
                return false;
            }
            return xhr;
        });
    };
});

